getMarketingConsent();
function getMarketingConsent() {
  const emailCheckbox = document.querySelector('#email_checkbox_marketing');
  const smsCheckbox = document.querySelector('#sms_checkbox_marketing');
  const customerId = emailCheckbox.dataset.customerid;

  fetch("/apps/spapp/getMareting", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ customerId }),
  }).then(result => result.json()
  ).then(data => {
    emailCheckbox.checked = 'subscribed' === data.email_marketing_consent;
    smsCheckbox.checked = 'subscribed' === data.sms_marketing_consent;
  })
}

function sendMarketingConsent() {
  const emailCheckbox = document.querySelector('#email_checkbox_marketing');
  const smsCheckbox = document.querySelector('#sms_checkbox_marketing');
  const smsMarketingStatut = smsCheckbox.checked ? 'subscribed' : 'unsubscribed';
  const emailMarketingStatut = emailCheckbox.checked ? 'subscribed' : 'unsubscribed';
  const customerId = emailCheckbox.dataset.customerid;
  const errorContainer = document.querySelector('.errors-contact.marketings');
  const spinner = document.querySelector('#lds-ring');
  const marketing_success = document.querySelector('.marketing_consent_success.marketings');
  marketing_success.style.display = "none";

  if (smsCheckbox.dataset.customerphone === '' && smsCheckbox.checked) {
    errorContainer.style.display = "block";
  }
  else {
    spinner.style.display = "inline-block";
    fetch("/apps/spapp/setMareting", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ customerId, smsMarketingStatut, emailMarketingStatut, hasPhoneNumber: smsCheckbox.dataset.customerphone !== '' }),
    }).then(result => result.json())
      .then(data => { spinner.style.display = "none"; errorContainer.style.display = "none"; marketing_success.style.display = "block" })
      .catch(err => { spinner.style.display = "none"; errorContainer.style.display = "none"; });
  }
}

function updateCustomer() {
  const fistName = document.querySelector('#customer_firstname');
  const lastName = document.querySelector('#customer_lastname');
  const phone = getCompletePhoneNumber();
  const days = document.querySelector('#select_days');
  const months = document.querySelector('#select_months');
  const years = document.querySelector('#select_years');
  const shopUrl = document.querySelector("[data-shopurl]");
  const customerId = fistName.dataset.customerid;
  const modifyInfos_error = document.querySelector('.errors-contact.modifyinfos');
  const spinner = document.querySelector('#lds-ring');
  const modifyInfos_success = document.querySelector('.marketing_consent_success.modifyinfos');
  modifyInfos_success.style.display = "none";

  console.log(phone);

  if (fistName.value === '' || lastName.value === '' || !isNaN(lastName.value) || !isNaN(fistName.value)) {
    modifyInfos_error.innerHTML = "Veuillez remplir toutes les entrées requises avec des informations valides";
    modifyInfos_error.style.display = "block";
  }
  else {
    const birthday = years.value + "-" + ("0" + months.value).slice(-2) + "-" + ("0" + days.value).slice(-2);

    spinner.style.display = "inline-block";
    fetch("/apps/spapp/updatecustomer", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ customerId, fistName: fistName.value, lastName: lastName.value, phone: phone, birthday }),
    }).then(result => result.json())
      .then(data => {
        fistName.value = data?.customerUpdate?.customer?.firstName;
        lastName.value = data?.customerUpdate?.customer?.lastName;
        phone.value = data?.customerUpdate?.customer?.phone;
        if (data?.metafieldsSet?.metafields[0]?.key !== 'birthday') {
          days.value = "";
          months.value = "";
          years.value = "";
        }

        if (data?.customerUpdate?.userErrors[0]?.field[0] === 'phone') {
          throw data?.customerUpdate?.userErrors[0]?.message;
        }

        spinner.style.display = "none";
        modifyInfos_error.style.display = "none";
        modifyInfos_success.style.display = "block";
      })
      .catch(err => {
        spinner.style.display = "none";
        modifyInfos_error.innerHTML = err;
        modifyInfos_error.style.display = "block";
      });
  }

}

//it returns the complete phone number dial_code + number
function getCompletePhoneNumber() {

  let countrySelect = document.querySelector('#contry_selector');
  let inputPhone = document.querySelector('#phone');
  let country = countrySelect.value;

  if (inputPhone.value.length > 0) {
    return libphonenumber.parsePhoneNumber(inputPhone.value, country)?.number;
  }else{
    return '';
  }
}

function displayPhoneNumber() {
  let countrySelect = document.querySelector('#contry_selector');
  let inputPhone = document.querySelector('#phone');

  const phonenumber = inputPhone.getAttribute('data-customerphone');
  if(phonenumber?.length > 0){
    const phoneObj = libphonenumber.parsePhoneNumberFromString( phonenumber );
    inputPhone.value = phoneObj?.nationalNumber;
    countrySelect.value = phoneObj?.country;
  }
  
}
//display the phone number if exist
displayPhoneNumber();



//start//---/////////////////// Loyalty subscription and unsubscription///////////////////

const checkbox_loyalty = document.querySelector('#checkbox_loyalty');
const button_submit_loyalty = document.querySelector('#button_submit_loyalty');
const checkbox_loyalty_container = document.querySelector('.checkbox_Container_loyalty');
const emailCheckbox_loyalty = document.querySelector('#email_checkbox_marketing_2');
const smsCheckbox_loyalty = document.querySelector('#sms_checkbox_marketing_2');
const customerId = checkbox_loyalty?.dataset?.customerid;
const customerEmail = checkbox_loyalty?.dataset?.customeremail;
const customerStorlandId = checkbox_loyalty?.dataset?.customerstorlandid;







//hide or show checkbox mail & sms
checkbox_loyalty.addEventListener('change',()=>{
  if (checkbox_loyalty.checked) {
    checkbox_loyalty_container.style.display = "grid";
  
  }else {
    checkbox_loyalty_container.style.display = "none";
    smsCheckbox_loyalty.checked = false;
    emailCheckbox_loyalty.checked = false;
  }})


function sendConsentLoyalty() {
  const errorContainer = document.querySelector('.errors-contact.storeland');
  const spinner = document.querySelector('#lds-ring');
  const marketing_success = document.querySelector('.marketing_consent_succes.loyalty');
  marketing_success.style.display = "none";


  if (smsCheckbox_loyalty.dataset.customerphone === '' && smsCheckbox_loyalty.checked) {
    errorContainer.style.display = "block";
  }
  else {
    const loyaltyStatus = {
      isFid : checkbox_loyalty.checked,
      smsConsent : smsCheckbox_loyalty.checked && checkbox_loyalty.checked,
      emailConsent : emailCheckbox_loyalty.checked && checkbox_loyalty.checked
    };
  
    spinner.style.display = "inline-block";
    fetch("/apps/spapp/setLoyaltyConsent", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({loyaltyStatus : loyaltyStatus,customerId, newCustomer : customerStorlandId !== ""}),
    }).then(() => { spinner.style.display = "none"; errorContainer.style.display = "none"; marketing_success.style.display = "block" })
      .catch(() => { spinner.style.display = "none"; errorContainer.style.display = "none"; });
  }
}

//end//---/////////////////// Loyalty subscription and unsubscription///////////////////